import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LoggedOutComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
